import React from "react";
import { Form } from 'react-bootstrap';

const CustomCheckBox = ({ label, handleChange, ids, value, validate, disabled }) => {
  return (
    <Form.Group controlId={ids} className="d-flex">
      <Form.Check type="checkbox" name={ids} onChange={handleChange} checked={value} required={validate} disabled={disabled} />
      {validate ? (
        <Form.Check.Feedback type="invalid" className="m-0 ms-1">
          {label ? label : ids} is required
        </Form.Check.Feedback>
      ) : null}
      {label ? (
        <Form.Label className="m-0 ms-2">{label}<span className="text-danger">{validate ? "*" : null}</span></Form.Label>
      ) : null}
    </Form.Group>
  )
}

export default CustomCheckBox;